import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useState, useEffect } from 'react'

interface LogoProps {
  className?: string
}

const Logo = ({ className = '' }: LogoProps) => {
  const [logoSrc, setLogoSrc] = useState<string | null>(null)
  
  // Try multiple possible paths for the KP24 logo
  const logoPaths = [
    '/logo.png',
    '/logo.jpg',
    '/logo.svg',
    '/assets/logo.png',
    '/assets/logo.jpg',
    '/assets/logo.svg',
    '/KP24-logo.png',
    '/KP24-logo.jpg',
    '/assets/KP24-logo.png',
  ]

  // Try to find the logo by testing image loading
  useEffect(() => {
    const testImage = (src: string): Promise<boolean> => {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = src
      })
    }

    const findLogo = async () => {
      for (const path of logoPaths) {
        const exists = await testImage(path)
        if (exists) {
          setLogoSrc(path)
          return
        }
      }
      // If no logo found, try first path anyway (might work after deployment)
      setLogoSrc(logoPaths[0])
    }

    findLogo()
  }, [])

  const handleImageError = () => {
    // If current path fails, try next one
    const currentIndex = logoPaths.indexOf(logoSrc || '')
    if (currentIndex < logoPaths.length - 1) {
      setLogoSrc(logoPaths[currentIndex + 1])
    }
  }

  return (
    <Link to="/" className={`flex items-center group relative z-10 flex-shrink-0 ${className}`}>
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3 }}
        className="relative flex items-center"
      >
        {/* Logo Image - Only image, no text fallback */}
        {logoSrc && (
          <img
            src={logoSrc}
            alt="KP24"
            className="h-9 sm:h-10 md:h-12 w-auto object-contain"
            style={{
              maxWidth: '200px',
            }}
            onError={handleImageError}
          />
        )}
      </motion.div>
    </Link>
  )
}

export default Logo
